import React from 'react';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from '../components/Footer';
import Header from '../components/Header';

const Hakkimizda = () => {
    return (
        <>
            <Helmet>
                <title>Hakkımızda - Legalbul</title>
                <link rel="canonical" href={`${window.location.origin}${window.location.pathname}`} />
                <meta name="description" content="Legalbul.com, alanında uzmanlaşmış ekibimiz tarafından kullanıma hazırlanmış bir hesaplama
                    platformudur." />
            </Helmet>

            <Header />
            <section className="container p-5 my-5 bg-white shadow-sm">
                <ol className="breadcrumbnav">
                    <li>
                        <Link to="/">Ana Sayfa</Link>
                    </li>
                    <li>
                        Hakkımızda
                    </li>
                </ol>
                <div>
                    <h1>Hakkımızda</h1>
                    Legalbul.com, alanında uzmanlaşmış ekibimiz tarafından kullanıma hazırlanmış bir hesaplama
                    platformudur. Amacımız, Türkiye'deki vatandaşların hukuki süreçlerde karşılaştıkları karmaşık hesaplamaları
                    daha anlaşılır ve erişilebilir hale getirmektir. Bu doğrultuda, hukuki işlemlerde işleyecek sürelerin hak
                    kaybı yaşanmadan hesaplanması ve bu hesaplamaların herkesçe anlaşılabilir olması da bu platformun başlıca
                    hedeflerinden biridir.
                </div>
                <div className="py-4">
                    <h3 className="py-1">Misyonumuz</h3>
                    <div>
                        Misyonumuz, hukuk alanında karşımıza çıkan hesaplamaların herkes için anlaşılır ve erişilebilir olmasını
                        sağlamaktır. Hukuk, toplumun uzlaşı içerisinde yaşaması için temel bir unsur olup, her bireyin kendi
                        haklarının ve yükümlülüklerinin farkına varması ve koruması gereken bir alanı temsil etmektedir. Bu
                        hakların korunması özellikle dava süreçlerinde sürelerin ve taleplerin doğru hesaplanmasıyla mümkündür.
                        Biz de bu bilinci güçlendirmek ve hukuki bilgiye erişimi kolaylaştırmak için çalışıyoruz.
                        Kullanıcılarımıza, hukuki süreçlerde talep etmeyi düşündükleri tazminatların hesaplanmasında ve bu
                        taleplere ilişkin sorunların çözüme kavuşmasında yardımcı olacak doğru ve güncel bilgiyi sunarak, hak
                        kaybı yaşanmaması konusunda katkıda bulunmayı amaçlıyoruz.
                    </div>
                </div>
                <div className="py-4">
                    <h3 className="py-1">Vizyonumuz</h3>
                    <div>
                        Vizyonumuz, Türkiye'de hukuk kültürünü güçlendirmek ve adaletin sağlanmasına katkıda bulunmaktır. Bu
                        doğrultuda, teknolojiyi ve yenilikleri kullanarak, kullanıcılarımıza en iyi hizmeti sunmayı
                        hedefliyoruz. Sürekli olarak platformumuzu geliştirerek, hukuki bilgiye erişimi daha da kolaylaştırmak
                        ve kullanıcı deneyimini iyileştirmek istiyoruz. Ayrıca, hukukun farklı alanlarına yönelik içeriklerini
                        ve hesaplamalarını zenginleştirerek, kullanıcılarımızın ihtiyaçlarını karşılamak ve hukukun çeşitli
                        yönlerini kapsayan kapsamlı bir başvuru kaynağı olmayı hedefliyoruz.
                    </div>
                </div>
                <div className="py-4">
                    <h3 className="py-1">Uyarı ve Sorumluluk</h3>
                    <div>
                        Sitemizde yer alan hesaplama modülleri alanında uzmanlaşmış hukukçular tarafından hazırlanmış olup,
                        hesaplamaların sonuçları yalnızca bilgilendirme amaçlıdır. Bu nedenle, sitemizde sunulan bilgilerin
                        yasal bir bağlayıcılığı bulunmamaktadır. Kullanıcılarımızın hukuki konularda profesyonel bir danışmanlık
                        alması ve kararlarını bu doğrultuda vermeleri önemlidir. Sürekli bir şekilde gelişmeye ve içeriklerimizi
                        zenginleştirmeye devam ediyoruz, bu gayretle kullanıcılarımızda süreklilik arz eden bir memnuniyet
                        istikrarı sağlamak için çaba gösteriyoruz.
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default React.memo(Hakkimizda);
